import {
  ApplicationConfig,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
  inject,
  isDevMode,
} from '@angular/core';
import {
  provideRouter,
  TitleStrategy,
  withComponentInputBinding,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
} from '@angular/router';
import { TranslocoTitleStrategy } from './core/title/transloco-title-strategy';

import { routes } from './app.routes';
import { provideKsgUi } from '@ksg/ui';
import { ThemeService } from './core/theme/theme.service';

import { provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { authInterceptor } from './core/auth/auth.interceptor';
import { TranslocoHttpLoader } from './transloco-loader';
import { provideTransloco } from '@jsverse/transloco';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }),
      withEnabledBlockingInitialNavigation(),
    ),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor]), withInterceptorsFromDi()),
    ...environment.mockProviders,
    provideZonelessChangeDetection(),

    provideKsgUi({ persist: false }),
    provideAppInitializer(() => inject(ThemeService).init()),
    { provide: TitleStrategy, useClass: TranslocoTitleStrategy },
    provideTransloco({
      config: {
        availableLangs: environment.languages,
        defaultLang: environment.defaultLanguage,
        fallbackLang: environment.defaultLanguage,
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
        missingHandler: {
          useFallbackTranslation: true,
        },
      },
      loader: TranslocoHttpLoader,
    }),
  ],
};
